import { RECEIVE_PARTNERS_API, POST_STEP_STATUS_FINISHED } from './types';

const initialState = []; // liste brute des partenaires renvoyée par /partners/all

const partnersApiReducer = (state = initialState, action) => {
	switch (action.type) {
		case RECEIVE_PARTNERS_API: {
			const { result, prefix } = action;

			// GET global : la réponse remplace toute la liste.
			if (!prefix) return Array.isArray(result) ? result : state;

			// GET ciblé : on ne remplace que le partenaire demandé. La réponse a
			// le même format que /partners/all, on la substitue donc telle quelle
			// (et non par merge) pour ne pas conserver un onboarding obsolète.
			const updated = Array.isArray(result)
				? result.find(p => p && (!p.prefix || p.prefix === prefix))
				: result;
			if (!updated) return state;

			return state.map(partner =>
				partner && partner.prefix === prefix
					? { ...updated, prefix }
					: partner
			);
		}

		case POST_STEP_STATUS_FINISHED: {
			const { prefix, partner: updated } = action;
			if (!prefix || !updated) return state;
			// Merge (pas remplacement) : le partenaire renvoyé ne porte que les
			// infos annexes + onboarding (et pas le prefix), on conserve
			// logo/nom/type/description et on cible par le prefix du body.
			return state.map(partner =>
				partner && partner.prefix === prefix
					? { ...partner, ...updated }
					: partner
			);
		}

		default:
			return state;
	}
};

export default partnersApiReducer;
